import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

/**
 * OktaService
 */
@Injectable({ providedIn: 'root' })
export class OktaService {
  private options = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  /**
   * url
   */
  public url;

  /**
   * constructor
   * @param {HttpClient} http
   */
  constructor(private http: HttpClient) {}

  resetPassword(body) {
    return this.http.post(
      `${environment.apiUrl}/User/expire_password`,
      JSON.stringify(body),
      {
        ...this.options,
      },
    );
  }
}
